export const emailValidator = {
  required: "Email is required",
  pattern: { value: /^[a-zA-Z0-9._:$!%-+]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/i, message: "Invalid email address" },
};

export const passwordValidator = { required: "Password is required" };

export const newPasswordValidator = {
  required: "Password is required",
  minLength: { value: 15, message: "Password must be at least 15 characters long" },
};

export const firstNameValidator = {
  required: "First Name is required",
  pattern: { value: /^[a-zA-Z\s]+$/, message: "Name must contain only letters and spaces" },
};

export const lastNameValidator = {
  required: "Last Name is required",
  pattern: { value: /^[a-zA-Z\s]+$/, message: "Name must contain only letters and spaces" },
};

export const ssnValidator = {
  required: "SSN is required",
  pattern: { value: /^\d{3}-\d{2}-\d{4}$/, message: "Invalid SSN format (XXX-XX-XXXX)" },
  validate: (value: string) =>
    /^(?!\b(\d)\1+-(\d)\1+-(\d)\1+\b)(?!123-45-6789|219-09-9999|078-05-1120)(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/.test(value)
      ? true
      : "Invalid SSN",
};

export const nameValidator = {
  required: "Name is required",
};

export const phoneValidatorOptional = {
  validate: (value: string) => {
    if (!value || value.replace(/\D/g, "").length === 0) return true;
    return /^\(\d{3}\)\s\d{3}-\d{4}$/.test(value) || "Invalid Phone Number format ((XXX) XXX-XXXX)";
  },
};

export const phoneValidatorRequired = {
  required: "Phone Number is required",
  ...phoneValidatorOptional,
};

export const textFieldFilterValidator = {
  maxLength: { value: 500, message: "Search content cannot exceed 500 characters" },
};
